module.exports = __webpack_public_path__ + "static/about-us-27476ff89ce23b8d315d405ae43157e1.jpg";